export const BARCODE = 'Barcode';
export const MOBILE_TRANSFER = 'ExtMobile';
export const MOBILE = 'Mobile';
export const PDF = 'PDF';
export const PAPER = 'Paper';
export const FLASH = 'FlashSeat';
export const EXT_FLASH = 'ExtFlash';

export const DEFAULT_TICKET_TYPES = Object.freeze([
  {
    ticketType: BARCODE,
    ticketDisplayText: 'Barcode',
    ticketIcon: 'barcode-ticket'
  },
  {
    ticketType: MOBILE_TRANSFER,
    ticketDisplayText: 'Mobile Transfer',
    ticketIcon: 'mobile-transfer'
  },
  {
    ticketType: PDF,
    ticketDisplayText: 'PDF',
    ticketIcon: 'pdf-ticket'
  },
  {
    ticketType: PAPER,
    ticketDisplayText: 'Paper Tickets',
    ticketIcon: 'paper-ticket'
  },
  {
    ticketType: FLASH,
    ticketDisplayText: 'AXS Tickets',
    ticketIcon: 'axs-ticket'
  },
  {
    ticketType: EXT_FLASH,
    ticketDisplayText: 'AXS Tickets',
    ticketIcon: 'axs-ticket'
  },
  {
    ticketType: MOBILE,
    ticketDisplayText: 'Mobile Screenshot',
    ticketIcon: 'mobile-screenshot'
  }
]);

export const SPLIT_SEATS_OPTIONS = Object.freeze({
  NONE: 'NONE',
  NOSINGLES: 'NOSINGLES',
  MULTIPLES: 'MULTIPLES'
});

export const TICKET_ATTRIBUTE_TYPES = Object.freeze({
  TICKET_FEATURE: 'Ticket Feature',
  SELLER_COMMENTS: 'Seller Comments',
  LISTING_DISCLOSURE: 'Listing Disclosure',
  LISTING_RESTRICTION: 'Listing Restrictions',
  LISTING_CONNECTION: 'Connected'
});

export const DEFAULT_SELL_TICKET_REDUX_STATE = Object.freeze({
  listingDeniedKey: null,
  ticketDetails: {
    sectionComplete: false,
    sectionSummary: [],
    restrictionsValid: false,
    limitationsValid: false,
    connectionsValid: false,
    splitOption: SPLIT_SEATS_OPTIONS.NONE,
    splitQuantity: null,
    ticketData: {
      section: null,
      row: '',
      fulfillmentType: '',
      seats: [],
      deliveryTypeIds: 5,
      noSeatNumbersCheckboxSelected: false
    },
    limitations: [],
    restrictions: [],
    features: [],
    connections: [],
    ticketTypeSelected: null,
    ticketQuantity: 1,
    inhandDate: '',
    deliverNow: true
  },
  pricing: {
    isValid: true,
    sectionComplete: false,
    sectionSummary: []
  },
  personalDetails: {
    isValid: false,
    sectionComplete: false,
    sectionSummary: []
  },
  sellerFramework: {
    sectionComplete: false,
    sectionSummary: []
  }
});

export const DEFAULT_SEAT_STATE = Object.freeze({
  fulfillmentArtifact: null,
  isValid: null,

  /* SeatTraits */
  buyerRestricted: null,
  row: null,
  seat: null,
  section: null
});

export const ReduxSellTicketActions = Object.freeze({
  PERSONAL_DETAILS: 'SELLTICKET:UPDATE_PERSONAL_DETAILS',
  PERSONAL_DETAILS_LOADING: 'SELLTICKET:UPDATE_PERSONAL_DETAILS_LOADING',
  UPDATE_PRICING: 'SELLTICKET:UPDATE_PRICING',
  UPDATE_PRICING_SUMMARY: 'SELLTICKET:UPDATE_PRICING_SUMMARY',
  SET_DEFAULT_SELL_TICKET_STATE: 'SELLTICKET:SET_DEFAULT_SELL_TICKET_STATE',
  TICKET_DETAILS: 'SELLTICKET:UPDATE_TICKET_DETAILS',
  UPDATE_SELLER_RESTRICTION: 'SELLTICKET:UPDATE_SELLER_RESTRICTION',
  UPDATE_EVENT_DETAILS: 'SELLTICKET:UPDATE_EVENT_DETAILS',
  INTEGRATED_EVENT_INFO: 'SELLTICKET:INTEGRATED_EVENT_INFO',
  GET_HW_USER_INFO: 'SELLTICKET:GET_HW_USER_INFO',
  SELLER_ELIGIBILITY_LOADING: 'SELLTICKET:SELLER_ELIGIBILITY_LOADING',
  SELLER_ELIGIBILITY: 'SELLTICKET:SELLER_ELIGIBILITY',
  SELLER_TAX_ID_VISIBLE: 'SELLTICKET:SELLER_TAX_ID_VISIBLE'
});

export const AccordionStep = Object.freeze({
  TICKET_DETAILS: 'ticketDetails',
  PRICING: 'pricing',
  PERSONAL_DETAILS: 'personalDetails',
  SELLER_FRAMEWORK: 'sellerFramework',
  TAX_INFO: 'taxInfo',
  NONE: 'none'
});
